<script lang="ts">
    import SliderInstance from './SliderInstance.svelte';

    export let label: string;
    export let valueMin: number | null;
    export let valueMax: number | null;
    export let defaultMin: number | undefined;
    export let defaultMax: number | undefined;

    $: resolvedMin = Number.isFinite(defaultMin) ? (defaultMin as number) : 0;
    $: resolvedMax = Number.isFinite(defaultMax) ? (defaultMax as number) : 0;

    $: clampedMin = Math.min(
        Math.max(valueMin ?? resolvedMin, resolvedMin),
        resolvedMax,
    );
    $: clampedMax = Math.min(
        Math.max(valueMax ?? resolvedMax, resolvedMin),
        resolvedMax,
    );

    function onChange(event: CustomEvent<{ min: number; max: number }>) {
        valueMin = event.detail.min === resolvedMin ? null : event.detail.min;
        valueMax = event.detail.max === resolvedMax ? null : event.detail.max;
    }
</script>

{#key `${resolvedMin}-${resolvedMax}`}
    <SliderInstance
        {label}
        valueMin={clampedMin}
        valueMax={clampedMax}
        defaultMin={resolvedMin}
        defaultMax={resolvedMax}
        on:change={onChange}
        on:change
    />
{/key}
